import styled from '@emotion/styled';
import { spacing, breakpoints } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Input, Label, Message } from '@naf/input';

export const InputBlockWrapper = styled.div`
  max-width: 410px;
`;

export const StyledLabel = styled(Label)`
  color: ${nafColor.signature.white || '#FFF'};
`;

export const StyledInput = styled(Input)`
  width: auto;
  @media (max-width: ${breakpoints.s}) {
    width: 35%;
  }
`;

export const InputAreaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${spacing.space24};
  @media (max-width: ${breakpoints.s}) {
    justify-content: flex-start;
  }
`;

export const StyledMessage = styled(Message)`
  background: ${({ theme }) =>
    theme.componentColors ? theme.componentColors.alert.errorBackground : theme.componentColors.alert.errorBackground};
  padding: ${spacing.space32} ${spacing.space24};
  margin-top: ${spacing.space24};
  color: ${nafColor.signature.black || '#000'};
  svg {
    color: ${({ theme }) => theme.componentColors.alert.error};
  }
`;
